<template>
  <div class="about_us_wrap">
    <navbar_ :Lucency="false" :isBlack="true" :activeIndex="'/aboutUs'" />

    <div class="about_container">
      <div class="affix_box">
        <el-affix target=".about_container" :offset="60">
          <div class="tab_list">
            <div
              class="tab_item"
              :class="{ tab_active: $route.path === item.path }"
              v-for="(item, index) in menuList"
              :key="index"
              @click="tabClick(item.path)"
            >
              {{ item.name }}
            </div>
          </div>
        </el-affix>
      </div>

      <div class="main_content">
        <router-view :key="$route.fullPath" />
      </div>
    </div>

    <footer_ />
  </div>
</template>

<script>
import navbar_ from "@/components/navbar/index.vue"; // 顶部导航
import footer_ from "@/components/footer/index.vue"; // 底部

export default {
  components: {
    navbar_,
    footer_,
  },
  data() {
    return {
      menuList: [
        {
          name: "关于益学",
          path: "/aboutUs",
        },
        {
          name: "益学聚焦",
          path: "/aboutUs/focus",
        },
        {
          name: "联系我们",
          path: "/aboutUs/contact",
        },
        {
          name: "益学提醒",
          path: "/aboutUs/warn",
        },
      ],
    };
  },
  methods: {
    // 左侧 tab click
    tabClick(path) {
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.about_us_wrap {
  padding-top: 60px;

  .about_container {
    min-height: calc(100vh - 60px);
    display: flex;

    .affix_box {
      width: 10%;
      background: #000;

      /deep/.el-affix {
        width: auto !important;
      }

      .tab_list {
        height: calc(100vh - 60px);
        background: linear-gradient(
          -20deg,
          #04080f 0%,
          #0e2b4c 53%,
          #040a0e 100%
        );

        .tab_item {
          height: 75px;
          line-height: 75px;
          font-size: 14px;
          color: #fff;
          text-align: center;
          cursor: pointer;
          box-sizing: border-box;

          &.tab_active {
            font-weight: bold;
            background: linear-gradient(
              90deg,
              rgba(18, 133, 255, 0.25) 0%,
              rgba(44, 219, 255, 0.25) 100%
            );
            border-right: 3px solid;
            border-image: linear-gradient(180deg, #2cdbff 0%, #1285ff 100%) 1;
          }
        }
      }
    }

    .main_content {
      width: 90%;
      // padding-left: 10%;
    }
  }
}
</style>
